<div class="py-5 px-2 position-relative" *ngIf="!forJSPage">
    <div class="py-4"></div>
    <div class="wrapper">
        <video id="headerVideo" autoplay="autoplay" muted="muted" webkit-playsinline="true" playsinline="true" loop="loop" preload="auto">
            <source src="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/products-header.mp4" type="video/mp4">
        </video>
    </div>
</div>

<div class="position-relative d-flex p-3 p-md-5 m-md-3 text-center bg-dark intro-banner" *ngIf="forJSPage">
  <div class="col-md-8 p-lg-5 mx-auto text-white align-self-center">
    <h1 class="font-weight-bold mx-auto pb-100px">{{'Nos contributeurs' | translate}}</h1>
  </div>
  <div class="contributors" *ngIf="forJSPage">
      <owl-carousel
          [items]="contributors"
          [options]="{
              items: 8,
              dots: false,
              nav: true,
              margin:0,
              loop:true,
              autoplay:true,
              autoplayTimeout:3000,
              autoplayHoverPause:true,
              responsive:{
                  '20':{
                      items:1,
                      nav:true
                  },
                  '400':{
                      items:2,
                      nav:true
                  },
                  '650':{
                      items:3,
                      nav:true
                  },
                  '768':{
                      items:4,
                      nav:true
                  },
                  '1080':{
                      items:6,
                      nav:true,
                      loop:true
                  },
                  '1500':{
                      items:8,
                      nav:true,
                      loop:true
                  },
                  '1800':{
                      items:9,
                      nav:true,
                      loop:true
                  }
              }
          }"
          [carouselClasses]="['owl-carousel']" class="owl-carousel px-5">
          <div class="item" *ngFor="let image of contributors;let i = index">
              <img class="mx-auto" alt="{{image.name}} logo" title="{{image.name}}" [attr.src]="image.url" loading="lazy"/>
          </div>
      </owl-carousel>
  </div>
</div>
<!-- <div class="contributors d-none d-xl-block m-md-3" *ngIf="forJSPage">
    <div class="contributors-logos">
        <div class="contributors-logos">
            <div class="contributor" *ngIf="contributors[0]"><img src="{{contributors[0].url}}" alt="logo of {{contributors[0].name}}" title="{{contributors[0].name}}" loading="lazy"></div>
            <div class="contributor" *ngIf="contributors[1]"><img src="{{contributors[1].url}}" alt="logo of {{contributors[1].name}}" title="{{contributors[1].name}}" loading="lazy"></div>
            <div class="contributor" *ngIf="contributors[2]"><img src="{{contributors[2].url}}" alt="logo of {{contributors[2].name}}" title="{{contributors[2].name}}" loading="lazy"></div>
            <div class="contributor" *ngIf="contributors[3]"><img src="{{contributors[3].url}}" alt="logo of {{contributors[3].name}}" title="{{contributors[3].name}}" loading="lazy"></div>
            <div class="contributor" *ngIf="contributors[4]"><img src="{{contributors[4].url}}" alt="logo of {{contributors[4].name}}" title="{{contributors[4].name}}" loading="lazy"></div>
            <div class="contributor" *ngIf="contributors[5]"><img src="{{contributors[5].url}}" alt="logo of {{contributors[5].name}}" title="{{contributors[5].name}}" loading="lazy"></div>
            <div class="contributor" *ngIf="contributors[5]"><img src="{{contributors[6].url}}" alt="logo of {{contributors[6].name}}" title="{{contributors[6].name}}" loading="lazy"></div>
        </div>
    </div>
</div> -->

<div class="filters mx-auto my-5 px-3" id="zone-filtres">
    <div class="position-relative">
        <!-- <div class="search">
            <input class="form-control" (ngModelChange)="handleKeyUp()" placeholder="{{'Rechercher' | translate}}" [(ngModel)]="searchString" name="searchString" aria-label="Rechercher" type="search">
        </div> -->
        <div class="btn-filtres rounded" (click)="toggleFilters()" *ngIf="!searchString" style="position: relative;height: 35px;width:auto">
            <span>{{'Filtres' | translate}}</span>
        </div>
    </div>
</div>
<div class="container-container position-relative px-4" id="products-zone">
    <div class="searchAndFilters pt-4" id="searchAndFilters" [ngClass]="{'d-block' : mobileFilters}" (click)="mobileFilters=false">

        <div class="" *ngIf="!forJSPage"><b>{{'Casques compatibles' | translate}} :</b></div>
        <div class="row mt-3" *ngIf="!forJSPage">
            <div class="col-4" *ngFor="let h of headsets">
                <picture>
                    <!-- <source srcset="{{h.webp}}" type="image/webp"> -->
                    <source srcset="{{h.png}}" type="image/png">
                    <img src="{{h.png}}" alt="{{h.name}} picture" loading="lazy"/>
                </picture>
            </div>
        </div>
        <hr class="my-4" *ngIf="!forJSPage">

        <div class="searchCont stickyTags" (click)="$event.stopPropagation()">
            <div class="searchTitle">
                {{'Filtres de recherche' | translate}}
                <i class="fa fa-times closeFilters" aria-hidden="true" (click)="mobileFilters=false"></i>
            </div>
            <!-- <div class="searchbar">
                <input class="form-control" placeholder="{{'Rechercher' | translate}}" [(ngModel)]="searchString" (ngModelChange)="handleKeyUp()">
            </div> -->

            <div *ngIf="pageDevicesOrNot==false" class="filters pb-5">
                <div class="filterCat" *ngFor="let category of categories | orderBy: 'number'"><div *ngIf="(!forJSPage && category.visible) || (forJSPage && jsPageForceCats.includes(category.id))">
                    <div *ngIf="!tagsDeployed[category.id.toString()] && category.id.toString() != initialTagDeployed" (click)="tagsDeployed[category.id.toString()]=true" class="filterTitle cursor-pointer">{{category.name}}<i class="fas fa-chevron-down depliant"></i></div>
                    <div *ngIf="tagsDeployed[category.id.toString()] && category.id.toString() != initialTagDeployed" (click)="tagsDeployed[category.id.toString()]=false;" class="filterTitle cursor-pointer">{{category.name}}<i class="fas fa-chevron-up depliant"></i></div>
                    <div *ngIf="category.id.toString() == initialTagDeployed" class="filterTitle">{{category.name}}</div>
                    <hr>
                    <div [ngClass]="{'closed':!tagsDeployed[category.id.toString()]}" class="mb-5">
                      <div class="pl-0 form-check" *ngFor="let tag of category.tags | orderBy : 'position'">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="tag{{tag.id}}" [disabled]="disableCheckbox" [(ngModel)]="checkedTags[tag['id'].toString()]" (change)="changeTags()">
                            <label class="custom-control-label" for="tag{{tag.id}}" [ngClass]="{'text-danger': tag['hideMethod']}">{{tag.name}}</label>
                        </div>
                      </div>
                    </div>

                </div></div>
            </div>

        </div>
    </div>
    <div class="product-container m-0 p-0 w-100">
        <div class="position-relative mb-3">
            <div class="pb-5 pb-0">
                <h2 *ngIf="pageDevicesOrNot==true && !forJSPage" class="my-4 text-center text-immersive"><b>{{"Catalog" | translate}} - {{deviceName}}</b></h2>
                <h1 class="text-center d-flex align-items-center justify-content-center mb-5 mb-md-0" style="height:126px;">
                    <b *ngIf="!forJSPage">{{"Les exercices sur la Santé, la Sécurité et l’Environnement"  | translate}}</b>
                    <b *ngIf="forJSPage">{{"More than 30 major accounts have participated in the development of this platform’s content"  | translate}}</b>
                </h1>


                <!-- <div *ngIf="!forJSPage && pageDevicesOrNot==false" class="mb-5 px-3 mt-3 mt-sm-0">
                  <div class="block">
                    <div class="container px-4 py-3">
                      <div class="row align-items-center">
                            <div class="col-sm-12 col-lg col-12 devicesTitle">{{'Casques compatibles' | translate}}</div>
                            <div *ngFor="let headset of headsets" class="col-sm-4 col-lg col-12 text-center headset mt-4 mt-lg-0 pt-4 pt-lg-0">
                              <picture>
                                  <source srcset="{{headset.webp}}" type="image/webp">
                                  <source srcset="{{headset.png}}" type="image/jpg">
                                  <img src="{{headset.png}}" alt="Picture of the {{headset.name}} headset" title="{{headset.name}}" loading="lazy">
                              </picture>
                              <p class="headsetTitle mt-3 mb-0 pb-0">{{headset.name}}</p>
                            </div>
                      </div>
                    </div>
                  </div>
                </div> -->


                <div class="loader" *ngIf="productsLoading"></div>
                <div *ngIf="!productsLoading">
                    <p *ngIf="filtersUsed() && pageDevicesOrNot==false" class="text-center mb-4 font-weight-bold">{{'Résultat(s) de la recherche' | translate}}: {{totalProductsNb}}</p>
                    <div class="row ml-0 mr-0">
                      <app-product-card class="col-md-3 mb-4"  *ngFor="let product of products" [product]="product"></app-product-card>
                    </div>
                    <div class="mt-4 text-center" *ngIf="totalProductsNb > products.length">
                        <button *ngIf="!showMoreLoading" class="btn btn-action mb-5" (click)="showMoreProducts()">{{'Afficher plus' | translate}}</button>
                        <div class="loader" *ngIf="showMoreLoading"></div>
                    </div>
                    <p class="text-center mt-4" *ngIf="!totalProductsNb">{{"Aucun résultats trouvés pour les paramètres choisis" | translate}}</p>
                </div>
            </div>
        </div>
    </div>
</div>
